export enum BackrestLightType{
        None,
        Fiber,
        LinearBar
}